import { render, staticRenderFns } from "./AlimtalkMng.vue?vue&type=template&id=1252e4e0&scoped=true"
import script from "./AlimtalkMng.vue?vue&type=script&lang=js"
export * from "./AlimtalkMng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1252e4e0",
  null
  
)

export default component.exports